import { talentCommentState } from './comments';
import { talentEmailState } from './emails';
var state = {
    loading: false,
    candidate: null,
    talent: null,
};
export var talentCard = {
    namespaced: true,
    state: state,
    mutations: {
        setCandidate: function (state, candidate) {
            state.candidate = candidate;
        },
        setTalent: function (state, talent) {
            state.talent = talent;
        },
    },
    modules: {
        talentCommentState: talentCommentState,
        talentEmailState: talentEmailState,
    },
};
